const ALLOWED_SLUGS = [
  'camgirl-lorena-neukt-live',
  'tiener-jennifer-wipt-live-op-webcam',
  'webcammen-met-natasja-en-valencia',
  'webcamgirl-chayenne-wordt-geneukt',
  'webcamgirl-joy-ontvangt-fan-voor-trio',
  'daphne-voorspelt-squirt-buien',
];

export default {
  computed: {
    showWebcamPromoBanner() {
      const currentSlug = this.$route.params.slug;
      return ALLOWED_SLUGS.includes(currentSlug);
    },
  },
};
